/* eslint-disable */
import { useEffect } from "react";

export default function ThankYou() {

  const redirectParentWindow =(url) => {
    window.parent.postMessage({ type: 'REDIRECT', url }, '*');
    console.log("Redirected User  to Thankyou Page ")
 }
  useEffect(()=>{
    // Get the purchase amount from URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const amount = urlParams.get('amount');

    // Construct the redirect URL with amount parameter if it exists
    const redirectUrl = amount
      ? `https://sajawal.school/thank-you?amount=${amount}`
      : "https://sajawal.school/thank-you";

    window.location.href = redirectUrl;
    // redirectParentWindow(redirectUrl)
  },[])
  return <div className="thankyou">
    <img src="/checkout/images/icon-thank-you.svg" alt="" />
    <h2>Thank you!</h2>
    <p>Thanks for confirming your subscription! we hope you have fun using our paltform. if you ever need support, please feel free to email us at Hello@Sajawal.School </p>
  </div>
}